module.exports = __webpack_public_path__ + "static/media/check.0f605d25.svg";